import { MaasModelSourceType } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';

/** 创建数据盘时，卷容量相对模型大小的额外预留（Gi） */
export const MODEL_DATA_VOLUME_BUFFER_GI = 5;

/** 暂未开放的模型来源类型（恢复 HTTP/S3 时移除此常量及相关过滤） */
export const DISABLED_MODEL_SOURCE_TYPES = new Set<MaasModelSourceType>([MaasModelSourceType.Http, MaasModelSourceType.S3]);
